import {Component, OnInit, Input} from '@angular/core';
import {WordpressPost} from "../../../domain/wordpress-post";

@Component({
    selector: 'wordpress-litte-post',
    templateUrl: './wordpress-litte-post.component.html',
    styleUrls: ['./wordpress-litte-post.component.scss']
})
export class WordpressLittePostComponent implements OnInit {

    @Input() post : WordpressPost;

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/news/wordpress-litte-post/wordpress-litte-post.component.ts